import type { SharedDriveRole } from "../types/shared-drive.js";

export const SHARED_DRIVE_ROLES = ["viewer", "editor", "manager"] as const;

const ROLE_WEIGHT: Record<SharedDriveRole, number> = {
  viewer: 1,
  editor: 2,
  manager: 3,
};

export interface SharedDriveCapabilities {
  canRead: boolean;
  canWrite: boolean;
  canManage: boolean;
}

export type AccessRole = SharedDriveRole | "owner" | null | undefined;

export function isSharedDriveRole(value: unknown): value is SharedDriveRole {
  return typeof value === "string" && SHARED_DRIVE_ROLES.includes(value as SharedDriveRole);
}

export function hasSharedDriveRole(actualRole: AccessRole, requiredRole: SharedDriveRole): boolean {
  if (!isSharedDriveRole(actualRole)) {
    return false;
  }

  return ROLE_WEIGHT[actualRole] >= ROLE_WEIGHT[requiredRole];
}

export function getSharedDriveCapabilities(role: AccessRole): SharedDriveCapabilities {
  return {
    canRead: hasSharedDriveRole(role, "viewer"),
    canWrite: hasSharedDriveRole(role, "editor"),
    canManage: hasSharedDriveRole(role, "manager"),
  };
}

export function canWriteForRole(role: AccessRole): boolean {
  return role === "owner" || role === "editor" || role === "manager";
}

export function canManageForRole(role: AccessRole): boolean {
  return role === "owner" || role === "manager";
}
